<div class="nearshoring-page">
  <!-- Intro Section -->
  <section class="intro">
    <div class="wrapper">
      <div class="pager">
        <div class="pager__line"></div>
        <div class="pager__dots">
          <div class="pager__dot"></div>
          <div class="pager__dot"></div>
          <div class="pager__dot"></div>
        </div>
      </div>
      <h1 class="intro__title">Nearshoring mit Coara</h1>
      <p class="intro__text">
        Ihr europäisches Entwicklungsteam.<br />
        Qualität ohne Kompromisse.<br />
        Mit einem risikofreien Weg zu Ihrem<br />
        eigenen Entwicklungszentrum.
      </p>
      <a [routerLink]="PATHS[ROUTES.NEARSHORING]" fragment="kontakt" class="intro__button button">
        <span>Kontakt aufnehmen</span>
        <i-feather name="arrow-right"></i-feather>
      </a>
    </div>
  </section>

  <!-- Main Banner -->
  <section class="main-banner">
    <div class="main-banner__wrapper">
      <h2 class="main-banner__title">Coara – Unternehmensprofil</h2>
      <p class="main-banner__text">
        Wir sind Ihr erfahrener Partner für SaaS-Produktentwicklung, Plattformbetrieb und den Aufbau europäischer Entwicklungsteams. Wir
        helfen Ihnen, Ihr Unternehmen profitabel zu machen.
      </p>
      <div class="main-banner__footer">
        <div class="main-banner__footer__text">Qualität. Effizienz. Europäische Standards.</div>
      </div>
    </div>
  </section>

  <div class="wrapper">
    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Über uns</h2>
      <p class="section__text">
        Coara ist Ihr erfahrener Partner für SaaS-Produktentwicklung und Plattformbetrieb. Wir sind erfahrene Seriengründer, die Ihr Team
        komplettieren und Ihr Unternehmen profitabel machen. Über die reine Softwareentwicklung hinaus bieten wir Ideation, Design, UX und
        Produktentwicklung. Coara ist Inkubator für Ihre neuen Ideen, Accelerator für Ihr Geschäft und Profitabilitätstreiber für Ihren CFO.
        Wir entwickeln digitale Produkte mit herausragender UX und Design.
      </p>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Unsere Kernkompetenzen</h2>
      <ul class="section__list">
        <li class="section__list__item"><strong>Großskalige SaaS-Plattformen</strong></li>
        <li class="section__list__item"><strong>Aufbau von Nearshore-Entwicklungsteams</strong></li>
        <li class="section__list__item"><strong>DevOps, anbieterunabhängige Cloud-Infrastruktur</strong></li>
        <li class="section__list__item"><strong>KI-gestützte Entwicklung & Lösungen</strong></li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Unternehmensübersicht</h2>
      <ul class="section__list">
        <li class="section__list__item"><strong>Gründung:</strong> 2018</li>
        <li class="section__list__item"><strong>CEO & Gründer:</strong> Christian Bolz</li>
        <li class="section__list__item"><strong>Standorte:</strong> Estland und Spanien</li>
        <li class="section__list__item"><strong>Mitarbeiterzahl:</strong> 11–50</li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Unsere Expertise</h2>
      <p class="section__text">
        Wir sind leidenschaftlich innovativ und möchten Ihre Ideen Wirklichkeit werden lassen. Unsere Spezialgebiete umfassen:
      </p>
      <ul class="section__list">
        <li class="section__list__item"><strong>SaaS, Daten, KI</strong></li>
        <li class="section__list__item">User Experience (UX) Design</li>
        <li class="section__list__item">Sicherstellung hoher Codequalität und Standards</li>
        <li class="section__list__item">KI-Agenten und Integration</li>
        <li class="section__list__item">KI-gestützte Entwicklung</li>
        <li class="section__list__item">Microservice-Architektur</li>
        <li class="section__list__item">Backend-Systeme mit NodeJS / NestJS, Kafka, Mongo, Postgres</li>
        <li class="section__list__item">Webentwicklung (Angular / React / Vue)</li>
        <li class="section__list__item">Mobile App Entwicklung</li>
        <li class="section__list__item">Monitoring (Kibana, Grafana)</li>
        <li class="section__list__item">REST APIs, Systemintegration</li>
        <li class="section__list__item">CRM & Loyalty-Lösungen</li>
        <li class="section__list__item">Shopify & E-Commerce-Integrationen</li>
        <li class="section__list__item">Wallet Passes</li>
        <li class="section__list__item">Internet of Things (IoT)</li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Unser Ansatz</h2>
      <p class="section__text">
        Als erfahrenes Gründerteam kennen wir die Herausforderungen, neue Ideen zum Leben zu erwecken und ein profitables Unternehmen
        aufzubauen. Wir begleiten Sie durch den gesamten Produktentwicklungszyklus:
      </p>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>Ideenfindung & Strategie:</strong> Wir helfen, Ihr Konzept zu schärfen und eine klare Produktstrategie zu entwickeln.
        </li>
        <li class="section__list__item">
          <strong>Design & UX:</strong> Wir schaffen intuitive, benutzerfreundliche Designs für herausragende Nutzererlebnisse.
        </li>
        <li class="section__list__item">
          <strong>Entwicklung:</strong> Unsere technische Expertise garantiert robuste, skalierbare Lösungen.
        </li>
        <li class="section__list__item">
          <strong>Wachstum & Skalierung:</strong> Wir helfen Ihnen, Ihr Geschäft zu beschleunigen und Marktanteile zu gewinnen.
        </li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Nearshoring-Exzellenz: Ihr europäisches Entwicklungsteam</h2>
      <p class="section__text">
        Wir sind spezialisiert auf den Aufbau leistungsstarker Nearshore-Entwicklungsteams, die europäische Talentqualität mit
        Kosteneffizienz verbinden. Unser Ansatz liefert mehr als nur Entwickler – wir schaffen voll integrierte Teams, die auf Ihre
        Geschäftsziele und technischen Anforderungen abgestimmt sind.
      </p>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Warum Nearshoring mit Coara?</h3>
      <div class="nearshoring-page__benefits">
        <div class="nearshoring-page__benefits__item">
          <h4>Qualität ohne Kompromisse</h4>
          <p class="section__text">
            Wir setzen auf strenge Qualitätsstandards durch standardisierte Entwicklungsprozesse, umfassende Code-Reviews und
            kontinuierliche Tests.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Kulturelle & Zeitzonen-Kompatibilität</h4>
          <p class="section__text">
            Unsere europäischen Teams arbeiten in passenden Zeitzonen und teilen kulturelles Verständnis sowie Geschäftserwartungen.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Kosteneffizienz</h4>
          <p class="section__text">
            Profitieren Sie von hochqualifizierten europäischen Talenten zu 30–40 % geringeren Kosten im Vergleich zu Teams in Westeuropa.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Skalierbarkeit & Flexibilität</h4>
          <p class="section__text">Erweitern oder verkleinern Sie Ihre Entwicklungskapazitäten flexibel – ohne administrativen Aufwand.</p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Umfassendes Management</h4>
          <p class="section__text">
            Wir übernehmen das komplette Teammanagement – von Recruiting und Training bis zu Performance-Monitoring und kontinuierlicher
            Verbesserung.
          </p>
        </div>
      </div>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Unser Nearshoring-Prozess</h3>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>Anforderungsanalyse:</strong> Wir verstehen Ihre technischen und kulturellen Anforderungen sowie Ihre Geschäftsziele.
        </li>
        <li class="section__list__item">
          <strong>Team-Design:</strong> Wir stellen ein Team nach Ihren Bedürfnissen zusammen – inklusive Rollen, Senioritätslevel und
          Spezialkenntnissen.
        </li>
        <li class="section__list__item">
          <strong>Talentauswahl:</strong> Unser Auswahlprozess stellt sicher, dass jedes Teammitglied sowohl technisch als auch kulturell
          passt.
        </li>
        <li class="section__list__item">
          <strong>Integration & Abstimmung:</strong> Wir etablieren Kommunikationswege, Entwicklungsstandards und Reporting nach Ihren
          Vorgaben.
        </li>
        <li class="section__list__item">
          <strong>Kontinuierliche Verbesserung:</strong> Regelmäßige Reviews und Optimierungen sichern Produktivität und Qualität.
        </li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Build-Operate-Transfer: Das Ownership-Modell</h2>
      <p class="section__text">
        Für Unternehmen, die langfristig ein eigenes Nearshore-Team aufbauen möchten, bieten wir unser innovatives
        <strong>Build-Operate-Transfer (BOT)</strong>-Modell – der risikofreie Weg zu Ihrem eigenen Entwicklungszentrum in Europa.
      </p>

      <p class="section__text">
        <strong>Build-Operate-Transfer (BOT): Ihr Weg zum eigenen Team</strong><br />
        <em>Gehen Sie nahtlos vom Start bis zur vollständigen Übernahme eines eingespielten Tech-Teams in Europa – ohne Vorab-Risiko.</em>
      </p>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Warum das BOT-Modell?</h3>
      <div class="nearshoring-page__benefits">
        <div class="nearshoring-page__benefits__item">
          <h4>Kein Vorab-Risiko</h4>
          <p class="section__text">
            Wir übernehmen Setup, rechtliche Rahmenbedingungen und Recruiting. Sie zahlen erst, wenn das Team einsatzbereit ist.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Kosteneffizienz</h4>
          <p class="section__text">
            Ersetzen Sie laufende Betriebskosten (OPEX) durch eine einmalige Investition (CAPEX) nach der Übernahme.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Bilanz- & Steueroptimiert</h4>
          <p class="section__text">Die Übertragung erfolgt als Anteilskauf – das optimiert Ihre Bilanz und spart Steuern.</p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Schnelle Markteinführung</h4>
          <p class="section__text">
            Nutzen Sie unsere vorgeprüften Talentpools z. B. in <strong>Estland</strong> oder <strong>Spanien</strong> und stellen Sie Teams
            in wenigen Wochen auf.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Nahtloser Übergang</h4>
          <p class="section__text">
            Wir kümmern uns um Training, kulturelle Integration und Prozesse – Sie übernehmen ein schlüsselfertiges Team.
          </p>
        </div>
      </div>
      <!--
      <h3 class="nearshoring-page__section__subtitle">Phasen & Zeitplan</h3>
      <table class="nearshoring-page__table">
        <thead>
          <tr>
            <th>Phase</th>
            <th>Zeitplan</th>
            <th>Kernaktivitäten</th>
            <th>Kundenvorteile</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Build</strong></td>
            <td>1–3 Monate</td>
            <td>
              - Recruiting <br />
              - Training & Onboarding <br />
              - Prozess- & KPI-Abstimmung
            </td>
            <td>Kein operativer Aufwand, Experten-Setup</td>
          </tr>
          <tr>
            <td><strong>Operate</strong></td>
            <td>3–12 Monate</td>
            <td>
              - Team-Management <br />
              - Agile Delivery & Reporting <br />
              - Kontinuierliche Optimierung
            </td>
            <td>Flexible Skalierung, Bezahlung nach Output</td>
          </tr>
          <tr>
            <td><strong>Transfer</strong></td>
            <td>1 Monat</td>
            <td>
              - Rechtliche/finanzielle Übergabe <br />
              - Wissenstransfer <br />
              - Post-Transfer-Support
            </td>
            <td>Volle Ownership, keine Überraschungen</td>
          </tr>
        </tbody>
      </table>

      <h3 class="nearshoring-page__section__subtitle">Preismodell</h3>
      <table class="nearshoring-page__table">
        <thead>
          <tr>
            <th>Phase</th>
            <th>Preisstruktur</th>
            <th>Kundenvorteil</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Build</strong></td>
            <td>Fixpreis (Recruiting, Training, Setup)</td>
            <td>Planbare Kosten</td>
          </tr>
          <tr>
            <td><strong>Operate</strong></td>
            <td>Tages-/Monatssatz pro Teammitglied</td>
            <td>Kosten an Produktivität gekoppelt</td>
          </tr>
          <tr>
            <td><strong>Transfer</strong></td>
            <td>Einmaliges CAPEX (Anteilskauf)</td>
            <td>Langfristige Kostensenkung gegenüber Outsourcing</td>
          </tr>
        </tbody>
      </table>
-->
      <h3 class="nearshoring-page__section__subtitle">Wettbewerbsvorteile</h3>
      <div class="nearshoring-page__competitive-advantages">
        <div class="nearshoring-page__competitive-advantages__item">
          <h4>Geschwindigkeit</h4>
          <p>Stellen Sie MVP-fähige Teams in <strong>30 Tagen</strong> über unsere Talentnetzwerke in Estland oder Spanien auf.</p>
        </div>
        <div class="nearshoring-page__competitive-advantages__item">
          <h4>Lokale Expertise, globale Standards</h4>
          <p>
            Tiefes Know-how in osteuropäischen Talentpools (Top-Rankings in der EU), ergänzt durch exzellente UX/UI- und Produktkompetenz
            aus Südeuropa. Wir folgen Sicherheitsstandards und ISO-Prozessen.
          </p>
        </div>
        <div class="nearshoring-page__competitive-advantages__item">
          <h4>Transparenz</h4>
          <p>Echtzeit-Performance-Dashboards während der Operate-Phase sorgen für volle Nachvollziehbarkeit.</p>
        </div>
        <div class="nearshoring-page__competitive-advantages__item">
          <h4>Post-Transfer-Support</h4>
          <p>90 Tage Support nach Übergabe (z. B. HR, Compliance, Leadership-Coaching) sichern Kontinuität.</p>
        </div>
      </div>

      <p>
        <strong>Verwirklichen Sie Ihre Vision</strong><br />
        <em>Lassen Sie uns Ihr Team aufbauen – damit Sie es morgen besitzen.</em>
      </p>

      <blockquote>
        "Ihr Team, unser Blueprint, null Risiko."
      </blockquote>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Estland: Der perfekte Standort für Ihr Entwicklungsteam</h2>
      <p class="section__text">
        Estland ist einer der attraktivsten Standorte für Technologieunternehmen und Entwicklungsteams in Europa. Als unser wichtigster
        Nearshoring-Hub bietet Estland einzigartige Vorteile:
      </p>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Digitale Vorreiternation</h3>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>Fortschrittlichste digitale Gesellschaft der Welt</strong><br />
          99 % aller Behördengänge sind online möglich. Unternehmensgründung in 18 Minuten, Steuererklärung in 3 Minuten.
        </li>
        <li class="section__list__item">
          <strong>E-Residency-Programm</strong><br />
          Das E-Residency-Programm ermöglicht es Nicht-Esten, ein Unternehmen komplett digital zu gründen und zu führen – ideal für
          internationale Firmen.
        </li>
        <li class="section__list__item">
          <strong>Papierlose Verwaltung</strong><br />
          Digitale Signaturen sind seit 2000 rechtsgültig – Verträge und Dokumente werden sicher online unterzeichnet.
        </li>
      </ul>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Geschäftsfreundliches Umfeld</h3>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>Transparente Steuergesetze</strong><br />
          Besteuerung nur auf ausgeschüttete Gewinne – Reinvestitionen bleiben steuerfrei.
        </li>
        <li class="section__list__item">
          <strong>Internationale Top-Rankings</strong>
          <ul class="section__list">
            <li class="section__list__item">#1 Steuerwettbewerbsfähigkeit (Tax Foundation)</li>
            <li class="section__list__item">Top 20 "Ease of Doing Business" (Weltbank)</li>
            <li class="section__list__item">#1 Internetfreiheit (Freedom House)</li>
          </ul>
        </li>
        <li class="section__list__item">
          <strong>Niedrigste Korruption in Osteuropa</strong><br />
          Estland zählt laut Transparency International zu den am wenigsten korrupten Ländern weltweit.
        </li>
      </ul>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Technische Exzellenz</h3>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>Hervorragende IT-Ausbildung</strong><br />
          Estland hat ein starkes MINT-Bildungssystem und zählt zu den besten Digitalstandorten der EU.
        </li>
        <li class="section__list__item">
          <strong>Innovationskultur</strong><br />
          Heimat von Skype, Wise und Bolt – die meisten Unicorns pro Kopf in Europa.
        </li>
        <li class="section__list__item">
          <strong>EU-Mitgliedschaft</strong><br />
          Voller Zugang zum EU-Binnenmarkt, starker IP-Schutz und regulatorische Sicherheit.
        </li>
      </ul>

      <p class="section__text">
        <strong
          >Wir beobachten kontinuierlich alle europäischen Länder für die besten Team-Standorte – Estland zählt regelmäßig zu den
          Top-Adressen.</strong
        >
      </p>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Ausgewählte Kundenreferenzen</h2>
      <div class="nearshoring-page__references">
        <div class="nearshoring-page__references__item">
          <h3>Convercus Loyalty Platform</h3>
          <p class="section__text">
            Entwicklung und Betrieb der Convercus Loyalty Platform, der führenden Loyalty-Lösung im DACH-Markt. Dieses Projekt demonstriert
            unsere Fähigkeit, großskalige SaaS-Plattformen mit Enterprise-Performance und Zuverlässigkeit zu entwickeln und zu betreiben.
            Seit März 2020 sind wir alleinverantwortlich für die Entwicklung und den Betrieb der Convercus-Plattform sowie die
            Implementierung kundenspezifischer Projekte.
            <strong
              >Kurz nach der Übernahme dieser Rolle wurde Convercus profitabel und konnte Umsatz und Profitabilität kontinuierlich
              steigern.</strong
            >
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>JeriCommerce</h3>
          <p class="section__text">
            Erfolgreiche Entwicklung und Launch von JeriCommerce im Shopify App Store, mit innovativen Wallet-Pass-Lösungen für E-Commerce
            und Einzelhandel als Komponente moderner Loyalty-Programme. Dieses Produkt zeigt unsere Expertise in der Entwicklung nahtloser
            Omnichannel-Kundenengagement-Tools, die Retention und Loyalität ergänzen. JeriCommerce zeichnet sich durch schnelle Installation
            und einfache Integration aus, sodass Händler Wallet-Pass-Technologie ohne umfangreiche technische Kenntnisse nutzen können.
            <strong>Co-Founder-Buyout 2025.</strong>
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>Drop</h3>
          <p class="section__text">
            Entwicklung der Technologieplattform für Yachtdrop & Villadrop, die unsichtbare Schicht der Gastfreundschaft. Drop ist ein
            Startup, das sich auf Ultra-Fast-Delivery-Services für den Luxus-Reisesektor spezialisiert. Die Lösung ermöglicht es
            Yachtbesitzern, Gästen und Crew, Premium-Produkte und -Dienstleistungen mit außergewöhnlicher Geschwindigkeit und
            Zuverlässigkeit zu erhalten. Dieses Projekt demonstriert unsere Fähigkeit, logistikoptimierte digitale Plattformen zu
            entwickeln, die auf die besonderen Bedürfnisse von High-Net-Worth-Kunden in exklusiven Märkten zugeschnitten sind. Durch die
            Kombination von anspruchsvollem Bestandsmanagement, Echtzeit-Tracking und einem Premium-Nutzererlebnis hat sich Yachtdrop als
            innovativer Dienstleister im Luxus-Marine-Sektor etabliert. Nach dem Einstieg als verantwortliches Tech-Team und der Übernahme
            einer strategischen CTO-Position <strong>verdoppelte Drop schnell seinen Wert und ist heute mit 5 Mio. € bewertet.</strong>
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>Plan M8 ("Plan Mate")</h3>
          <p class="section__text">
            Produktdesign und Entwicklung einer anspruchsvollen SaaS-Anwendung für geplante und ungeplante Wartung auf Yachten. Mit unserer
            Unterstützung sicherte das Projekt zunächst eine Pre-Seed-Finanzierung von 150.000 € und wurde in das Yachting Ventures
            Accelerator-Programm aufgenommen. Die App bietet Offline-Funktionalität (essentiell für Offshore-Nutzung), moderne
            API-Architektur und anpassbare Wartungsvorlagen. Plan M8 adressiert eine kritische Lücke im Marine-Wartungssektor und bietet
            Yachtbesitzern, Betreibern, Kapitänen und Ingenieuren eine effiziente Lösung zur Verwaltung von Wartungsaufgaben und Reduzierung
            von Betriebskosten. Plan M8 wird heute auf einer Flotte von Yachten und Superyachten bis zu 50m eingesetzt.
            <strong>Auf den größten Yachten orchestriert Plan M8 jährliche Wartungsbudgets von mehreren Millionen Euro.</strong>
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>RiscBal</h3>
          <p class="section__text">
            Entwicklung eines fortschrittlichen Visualisierungssystems für Naturkatastrophenwarnungen. Diese Lösung wurde in Zusammenarbeit
            mit einem Spin-off der Universität der Balearen entwickelt. Sie demonstriert unsere Expertise in der Entwicklung komplexer
            Datenvisualisierungstools, die kritische Informationen für Notdienste effektiv, sicher und zeitnah kommunizieren. Das System
            hilft Nutzern, potenzielle Naturkatastrophen zu verstehen und darauf zu reagieren, und zeigt unsere Fähigkeit, Lösungen für
            bedeutende gesellschaftliche Herausforderungen zu entwickeln.
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>Radcliffe Research Platform</h3>
          <p class="section__text">
            Entwicklung einer spezialisierten medizinischen Forschungsplattform für die Radcliffe Group in Zusammenarbeit mit der
            International Society of Cardiovascular Pharmacotherapy (ISCP). Die Plattform ermöglicht die Erstellung eines Clinical Consensus
            Document on Antiplatelet Therapy in Acute Coronary Syndrome durch Expert Crowdsourcing. Das System ermöglicht es Kardiologen,
            medizinische Literatur zu überprüfen, an strukturierten Umfragen teilzunehmen und zur evidenzbasierten Konsensbildung
            beizutragen. Die Plattform umfasst fortschrittliche Dokumentenverwaltung, Expertenidentifikation und statistische
            Analysekomponenten, die individuelle Experteneinschätzungen in handlungsrelevante Konsensdaten transformieren. Dieses Projekt
            zeigt unsere Expertise in der Entwicklung spezialisierter Forschungstools für den Gesundheitssektor, die globale Zusammenarbeit
            unter medizinischen Fachleuten erleichtern und zu wissenschaftlichen Publikationen beitragen.
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>Baroon</h3>
          <p class="section__text">
            Entwicklung einer digitalen Lösung für effizientes Immobilienmanagement, die revolutioniert, wie Immobilienbesitzer und
            Managementgesellschaften kommunizieren. Baroon vereinfacht den Informationsaustausch durch eine moderne, benutzerfreundliche
            mobile Anwendung, die Immobilienmanagement effizienter, ortsunabhängig und zeitnah macht. Die Plattform hilft
            Immobilienmanagern, die für administrative Aufgaben aufgewendete Zeit zu reduzieren, sodass sie sich auf den Kundenservice
            konzentrieren können. Als sich entwickelnde Plattform passt sich Baroon kontinuierlich an die Bedürfnisse von
            Immobilienbesitzern und Managern an und demonstriert unsere Fähigkeit, innovative Lösungen für traditionelle Branchen im
            digitalen Wandel zu entwickeln.
          </p>
        </div>
      </div>
    </section>

    <section id="kontakt" class="nearshoring-page__contact section">
      <h2 class="nearshoring-page__contact__title section__title">Kontaktinformationen</h2>
      <ul class="section__list">
        <li class="section__list__item"><strong>CEO & Gründer:</strong> Christian Bolz</li>
        <li class="section__list__item"><strong>Telefon:</strong> +34 605 140 269</li>
        <li class="section__list__item"><strong>E-Mail:</strong> <a href="mailto:chris@coara.co">chris@coara.co</a></li>
        <li class="section__list__item"><strong>Website:</strong> <a href="https://coara.co" target="_blank">https://coara.co</a></li>
        <li class="section__list__item">
          <strong>LinkedIn:</strong>
          <a href="https://www.linkedin.com/company/coara" target="_blank">https://www.linkedin.com/company/coara</a>
        </li>
        <li class="section__list__item"><strong>Hauptsitz:</strong> Tallinn, Estland</li>
        <li class="section__list__item"><strong>Entwicklungsbüros:</strong> Palma de Mallorca, Spanien</li>
      </ul>
    </section>
  </div>

  <!-- Closing Banner -->
  <section class="sentence">
    <div class="sentence__wrapper">
      <p class="sentence__text">
        "Nearshoring mit Coara bedeutet: Ihr Team, unser Blueprint, null Risiko."
        <span class="signature">Christian Bolz, CEO & Gründer</span>
      </p>
    </div>
  </section>
</div>
